import styled from 'styled-components';

// Styles here were extracted with CustomFields in mind.
export const StyledLabel = styled.label`
  margin-bottom: 8px;
  margin-top: 16px;
  width: max-content;

  display: flex;
  align-items: center;
  column-gap: 8px;
  & > span {
    font-size: 12px;
    color: #474d66;
    font-weight: 500;
  }
`;
